import Projects from '../components/projects.svelte'
import basicScroll from 'basicscroll'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

export default {
	init() {
		scrollReveals()
		parallax()
		let $projectsWrap = $('#projects-app')
		if ($projectsWrap.length) {
			new Projects({
				target: $projectsWrap[0],
				props: $projectsWrap.data(),
			})
		}
	},
	finalize() {},
}

function scrollReveals() {
	let $projectsOverview = $('.projects-overview')
	if ($projectsOverview.length) {
		let prj_tl = gsap.timeline({
			scrollTrigger: {
				trigger: '.projects-overview',
				start: 'top center+=300', // when the top of the trigger hits the center of the viewport
				// markers: true,
			},
		})
		prj_tl.fromTo(
			'.projects-overview > h2',
			{
				opacity: 0,
				x: -80,
			},
			{
				delay: 0.25,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		prj_tl.fromTo(
			'.projects-overview > p[class=has-large-font-size]',
			{
				opacity: 0,
				x: 80,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		prj_tl.fromTo(
			'.projects-overview > p:not([class=has-large-font-size])',
			{
				opacity: 0,
				x: -80,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 1,
				x: 0,
			}
		)
		prj_tl.fromTo(
			'.projects-overview > .bg-word',
			{
				opacity: 0,
				x: -200,
			},
			{
				delay: 0,
				duration: 0.5,
				opacity: 0.9,
				x: -155,
			}
		)
	}
}

function parallax() {
	let scrollAnimations = []

	scrollAnimations.push(
		basicScroll.create({
			elem: $('.main-content-wrap .compass-svg')[0],
			from: 'top-bottom',
			to: 'bottom-top',
			direct: true,
			props: {
				'--pr':
					innerWidth > 600
						? {
								from: '55deg',
								to: '40deg',
						  }
						: {
								from: '55deg',
								to: '40deg',
						  },
			},
		})
	)

	scrollAnimations.push(
		basicScroll.create({
			elem: $('.main-content-wrap  .compass-svg:nth-of-type(2)')[0],
			from: 'top-bottom',
			to: 'bottom-top',
			direct: true,
			props: {
				'--pr2':
					innerWidth > 600
						? {
								from: '-20deg',
								to: '5deg',
						  }
						: {
								from: '-20deg',
								to: '5deg',
						  },
			},
		})
	)

	if (scrollAnimations.length) {
		scrollAnimations.forEach((instance) => instance.start())
	}
}
